<template>
  <section class="mb-0 auto-height" id="contact">
      <div class="container">
        <h3 class="text-center mb-0">聯絡我們</h3>
        <br>
        ※ 請正確填寫以下項目，若資訊有誤可能導致我們無法回覆您喔！
        <br>
        <br>
        <div width="50%">
          <div class="form-group text-left">
            <label class="contact-label">姓名</label>
            <input v-model="name" class="form-control" placeholder="請輸入您的大名" @change="checkFilled('name')">
          </div>
          <div class="form-group text-left">
            <label class="contact-label">電話(包含國碼，如台灣886、大陸地區86)</label>
            <input v-model="phone" class="form-control" placeholder="+886 912-345-678" @change="checkPhone()">
          </div>
          <div class="form-group text-left">
            <label class="contact-label">Email</label>
            <input v-model="email" type="email" class="form-control" placeholder="name@example.com" @change="checkEmail()">
          </div>
          <div class="form-group text-left">
            <label class="contact-label">意見內容 / 聯絡事項</label>
            <textarea v-model="content" class="form-control" rows="5" @change="checkFilled('content')"></textarea>
          </div>
          <button class="btn btn-light" @click="handleSubmit()">送出</button>
        </div>
      </div>
  </section>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Contact',
  data() {
    return {
      name: '',
      phone: '',
      email: '',
      content: '',
      nameError: '',
      phoneError: '',
      emailError: '',
      contentError: ''
    }
  },
  methods: {
      handleSubmit() {
        if (!this.name || !this.phone || this.email || !this.content) {
          alertify.alert('京倫建設', '很抱歉，請再次確認您輸入的資料是否完整喔！');
          return;
        }
        const newEmail = {
          name: this.name,
          phone: this.phone,
          email: this.email,
          msg: this.content,
        }
        this.name = '';
        this.phone = '';
        this.email = '';
        this.content = '';
        axios.post('/api/contact', newEmail).then(()=>{
          alertify.alert('京倫建設', '謝謝您的聯絡，我們會盡快回覆您！');
        });
      }
  }
}
</script>

<style scoped>
  .contact-label {
    text-align: left;
  }
</style>